import { instance } from '@/services/klarbuss-api'
import { Ramp } from '@/types/ramp'
import { AxiosResponse } from 'axios'

export function getRamps(): Promise<AxiosResponse<Ramp[]>> {
  return instance.get(`/ramp`)
}
